import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasFeature } from '../config/branding';

/**
 * Route guard for edition feature flags. Renders children only if the feature
 * is enabled for the current edition; otherwise redirects to the dashboard.
 * Use alongside ProtectedRoute (role checks) — this gates by edition.
 */
interface Props {
  feature: string;
  children: React.ReactNode;
}

const RequireFeature: React.FC<Props> = ({ feature, children }) => {
  if (!hasFeature(feature)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};

export default RequireFeature;
